<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-dialog
      :title="'7 GÜNLÜK '+data.Baslik+' KAYITLARI'"
      :visible="KasaDetayModal"
      v-if="KasaDetayModal"
      center
      width="95%">
      <a @click="$emit('KasaDetayModal', false)" class="ModalKapat"><i class="el-icon-close"></i></a>

      <el-alert
        v-if="!tableDisplay && !lo"
        type="info"
        :closable="false"
        description="7 Günlük Kayıt Bulunamadı">
      </el-alert>
      <el-table
        v-if="tableDisplay"
        class="table-xs "
        :data="tableData"
        style="width: 100%"
        width="100%"
        show-summary
        :height="Height"
        :summary-method="TableFooter"
        :row-class-name="TableClass"
      >
        <el-table-column
          label="İşlem Tarihi"
          prop="İşlem Tarihi"
          width="150">
        </el-table-column>
        <el-table-column
          label="Ödeme Tarihi"
          prop="Ödeme Tarihi"
          width="100">
        </el-table-column>
        <el-table-column
          label="Muhatap"
          prop="Muhatap"
          width="200">
        </el-table-column>
        <el-table-column
          label="Site/Bina"
          prop="Site/Bina"
          width="200">
        </el-table-column>
        <el-table-column
          label="Kasa"
          prop="Kasa"
          width="100">
        </el-table-column>
        <el-table-column
          label="Makbuz No"
          prop="MakbuzNo"
          width="100">
          <template slot-scope="scope">
            <a v-if="scope.row.MakbuzNo" @click="MakbuzGetir(scope.row.MakbuzNo)">
              <span>{{ scope.row.MakbuzNo }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column
          label="Açıklama"
          prop="Açıklama">
        </el-table-column>
        <el-table-column
          label="Kullanıcı"
          prop="Kullanıcı"
          width="100">
        </el-table-column>

        <el-table-column
          label="Gelir"
          prop="Gelir"
          width="120"
          align="right">
        </el-table-column>
        <el-table-column
          label="Gider"
          prop="Gider"
          width="120"
          align="right">
        </el-table-column>
        <el-table-column
          label="Bakiye"
          prop="Bakiye"
          width="120"
          align="right">
        </el-table-column>
      </el-table>
    </el-dialog>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>
import MakbuzDetay from "../../../../Vezne/MakbuzDetay";
import Yukleniyor from "../../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor, MakbuzDetay},
  props: {
    KasaDetayModal: Boolean,
    data: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      lo: false,
      MakbuzDetayModal: null,
      mNo: null,
      tableData: [],
      tableDisplay: false,
      AltToplam: {
        Gelir: 0,
        Gider: 0,
        Bakiye: 0
      },
      Height: '70vh',
      Form: {
        Bina_id: null,
        Kasa_id: null
      }

    }
  },
  methods: {
    MakbuzGetir(mNo) {
      this.mNo = mNo;
      this.MakbuzDetayModal = true
    },
    TableClass({row}) {
      return row.TableClass
    },
    TableFooter() {
      const sums = [];
      sums[8] = this.AltToplam.Gelir;
      sums[9] = this.AltToplam.Gider;
      sums[10] = this.AltToplam.Bakiye;
      return sums;
    },
    SayfaYukle() {
      this.Form = {
        Bina_id: this.data.Bina_id == "Sirket" ? null : this.data.Bina_id,
        Kasa_id: this.data.Kasa_id
      };
      this.lo=true
      this.$store.dispatch("Post", {...this.Form, path: 'raporlama/kasa/ekstre'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.tableData = response.tableData;
            this.AltToplam = response.AltToplam;
            if (this.tableData) this.tableDisplay = true;
            this.Height = '72vh';
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })
    }
  },
  created() {
    this.SayfaYukle();
  },
  computed: {
    rSAyfaYukle() {
      return this.data
    },
  },
  watch: {
    rSAyfaYukle() {
      this.SayfaYukle();
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/KasaDetay.vue